import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { getRecipeDetailAfterLoginApi, getRecipeDetailBeforeLoginApi } from '../../api/recipe.api';
import { createExchangeRecipeApi } from '../../api/exchange.api'
import { showSignInPopup } from '../../redux/auth.slice';
import swal from 'sweetalert';
import RecipeDetail from '../../components/RecipeDetailComponent/RecipeDetail';
import VotingContainer from './VotingContainer';
import ReviewContainer from './ReviewContainer';

const RecipeDetailContainer = () => {
    let { id } = useParams();
    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const time = useSelector(state => state.time.value);
    const dispatch = useDispatch();
    const ref = useRef(null);
    const [recipe, setRecipe] = useState();

    /**
     * When the button is clicked, scroll to the element with the ref of 'ref' using the smooth
     * behavior.
     */
    const handleClickToScroll = () => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }

    /**
     * If the user is logged in, then get the recipe details from the API, otherwise show the sign in
     * popup.
     */
    const toggleShowMoreDetails = () => {
        if (currentUser) {
            getRecipeDetailAfterLoginApi(recipe.id, currentUser.token)
                .then(res => {
                    const data = res.data;
                    typeof (data) !== "string" && setRecipe(res.data);
                    typeof (data) === "string" && swal({
                        // title: "Failed!",
                        text: "If you want to viewing recipe details, you must use your points to exchange this recipe!",
                        icon: "warning",
                        buttons: "OK",
                    });
                })
                .catch(err => {
                    console.log(err)
                })
        } else {
            dispatch(showSignInPopup());
        }
    }

    const toggleExchangeRecipe = () => {
        if (currentUser) {
            createExchangeRecipeApi({
                userId: currentUser.id,
                recipeId: recipe.id
            }, currentUser.token)
                .then(res => {
                    if (res.data === "success") {
                        swal({
                            icon: "success",
                            text: "exchange success!"
                        })
                        // toast.success("exchange success!");
                    } else {
                        swal({
                            icon: "warning",
                            text: res.data
                        })
                    }
                    console.log(res.data);
                })
                .catch(err => {
                    console.log(err)
                })
        } else {
            dispatch(showSignInPopup());
        }
    }

    useEffect(() => {
        getRecipeDetailBeforeLoginApi(id)
            .then(res => {
                setRecipe(res.data);
            })
            .catch(err => {
                console.log(err)
            })
    }, [id, time])

    return (
        <div className='recipe-detail-container' ref={ref}>
            <RecipeDetail recipe={recipe} />
            {(!recipe?.note && !recipe?.processingSteps && !recipe?.ingredients) &&
                <div className="view-more">
                    <button className="view-more-btn"
                        onClick={toggleShowMoreDetails}
                    >
                        VIEW MORE
                    </button>
                    <button className="view-more-btn"
                        onClick={toggleExchangeRecipe}
                    >
                        EXCHANGE
                    </button>
                </div>}
            {recipe && <>
                <VotingContainer recipe={recipe} toast={toast} />
                <ReviewContainer recipe={recipe} toast={toast} toggleScroll={handleClickToScroll} />
            </>}
        </div>
    )
}

export default RecipeDetailContainer